const axios = require('axios');
import apiUrl from '../../api.config';

const TAG_CATEGORY_API_URL = `${apiUrl}tagCategory`;

const TagCategoryService = {
    getBySchool() {
        return axios.get(TAG_CATEGORY_API_URL + '/getBySchool', {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    add(tagCategoryData) {
        return axios.post(TAG_CATEGORY_API_URL + '/add', tagCategoryData, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    update(tagCategoryData) {
        return axios.post(TAG_CATEGORY_API_URL + '/update', tagCategoryData, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    delete(tagCategoryIds) {
        return axios.post(TAG_CATEGORY_API_URL + '/delete', tagCategoryIds, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            },

        })
    }
}

export default TagCategoryService;